/** Baş harfli kimlik işareti. Fotoğraf yok (kişisel veri minimizasyonu). */
export function Avatar({ initials, size = 36, label }: { initials: string; size?: number; label?: string }) {
  // Baş harflerden kararlı bir ton: renk kimliği değil, yalnızca ayırt etmeye yardım.
  const hue = [...initials].reduce((h, c) => (h * 31 + c.charCodeAt(0)) % 6, 0);
  return (
    <span className={`avatar avatar--${hue}`} style={{ width: size, height: size, fontSize: size * 0.4 }} aria-hidden={label ? undefined : true} title={label}>
      {initials}
    </span>
  );
}
